import React from 'react';
import { AnyEmptyQuestion } from '../../../types';
import { DragDropContext, DropResult } from 'react-beautiful-dnd';
import DroppableSectionsList from './DragAndDrop/DroppableSectionsList';
import { reorder, reorderSections } from '../../../../PlusWebsiteEditor/components/DraggableHOC/Draggable.utils';
import { useDispatch } from 'react-redux';
import { setQuestions } from '../../../../../redux/questionnaire/actions';
import { groupQuestionsBySections } from '../QuestionnaireViewerEditor/utils';

interface Props {
  questions: AnyEmptyQuestion[];
}

const QuestionsList = ({ questions }: Props) => {
  const dispatch = useDispatch();

  function handleDragEnd(dropResult: DropResult) {
    const { destination, type } = dropResult;

    if (!destination) return;

    if (type === 'SECTION') {
      const sections = groupQuestionsBySections(questions);
      const reorderedSections = reorderSections(sections, dropResult);

      const updatedQuestions = reorderedSections.flatMap((section, sectionIndex) =>
        section.questions.map(question => ({
          ...question,
          section: sectionIndex + 1
        }))
      );

      dispatch(setQuestions(updatedQuestions));
    } else {
      const reorderedQuestions = reorder(questions, dropResult);
      dispatch(setQuestions(reorderedQuestions));
    }
  }

  const sections = groupQuestionsBySections(questions);

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <DroppableSectionsList questions={questions} sections={sections} onDragEnd={handleDragEnd} />
    </DragDropContext>
  );
};

export default QuestionsList;
